import { Badge, createTheme } from '@mantine/core'

// #1075 デザインシステム: 既存ブランドカラー($navy: #5A87C8)を踏襲した10段階カラーランプ。
// 500が現行ロゴ・既存画面そのままの色。CTA等はコントラスト確保のため700を使う(primaryShade)。
const brand = [
  '#EEF2FA', // 0
  '#DBE4F4', // 1
  '#B7C9E9', // 2
  '#93ADDD', // 3
  '#7A99D3', // 4
  '#5A87C8', // 5 - 既存ブランドカラー
  '#4A71AC', // 6
  '#3E5C94', // 7 - CTA等の既定色
  '#2F4670', // 8
  '#1F2A3D', // 9
]

export const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: 7,
  defaultRadius: 'sm',
  colors: {
    brand,
  },
  fontFamily: '"Noto Sans JP", "Hiragino Sans", sans-serif',
  fontFamilyMonospace: '"JetBrains Mono", monospace',
  headings: {
    fontFamily: '"Zen Kaku Gothic New", "Noto Sans JP", sans-serif',
    fontWeight: '700',
  },
  components: {
    // Mantine の Badge は既定で text-transform: uppercase。スキル名(JavaScript 等)や
    // 日本語ラベルの表記を変えないよう、全 Badge で大文字化を無効にする。
    Badge: Badge.extend({
      defaultProps: { tt: 'none' },
    }),
  },
})
